import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_GRAPHQL_ENDPOINT}`,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      apikey: `${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;